import React from "react";
import Header from "../layout/Header";
import aboutImage from "../../assets/about.jpg";
import LogoAbout from "../../assets/SorinBlack.png"; 

const BrandProfile = () => {
  return (
    <>
      {/* ✅ Global reset untuk full width */}
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          html, body {
            margin: 0 !important;
            padding: 0 !important;
            overflow-x: hidden;
            width: 100%;
            background-color: #f7f7f5;
          }
          
          body > div,
          #root,
          #root > div {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
          }

          /* ✅ HAPUS PADDING dari section brand */
          #brand {
            padding: 0 !important;
            margin: 0 !important;
          }

          @media (max-width: 1024px) {
            .brand-section {
              padding: 100px 50px !important;
              gap: 50px !important;
            }
          }

          @media (max-width: 768px) {
            .brand-section {
              flex-direction: column !important;
              padding: 80px 30px !important;
              gap: 40px !important;
            }
            .brand-text {
              text-align: center !important;
              padding: 0 20px !important;
            }
            .brand-text h2 {
              text-align: center !important;
            }
            .brand-text p {
              text-align: center !important;
            }
            .logo-container {
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
          }

          @media (max-width: 480px) {
            .brand-section {
              padding: 60px 24px !important;
            }
            .brand-text {
              padding: 0 15px !important;
            }
            .brand-text h2 {
              font-size: 1.4rem !important;
            }
            .brand-text p {
              font-size: 0.95rem !important;
              line-height: 1.6 !important;
            }
          }
        `}
      </style>

      <div
        style={{
          width: "100%",
          backgroundColor: "#f7f7f5",
          overflowX: "hidden",
          margin: 0,
          padding: 0,
        }}
      >
        <Header />

        {/* === SECTION MAIN === */}
        <section
          id="brand"
          className="brand-section"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            padding: "120px 80px 80px 80px",
            gap: "80px",
            boxSizing: "border-box",
            flexWrap: "wrap",
            width: "100vw",
            backgroundColor: "#f7f7f5",
            margin: 0,
          }}
        >
          {/* === LEFT IMAGE === */}
          <div
            style={{
              flex: "1",
              minWidth: "360px",
              maxWidth: "560px",
            }}
          >
            <img
              src={aboutImage}
              alt="SORIN perfume collection"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                objectFit: "cover",
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              }}
            />
          </div>

          {/* === RIGHT TEXT === */}
          <div
            className="brand-text"
            style={{
              flex: "1",
              minWidth: "360px",
              maxWidth: "600px",
              textAlign: "left",
              padding: "0 40px", // ✅ Padding kanan kiri
            }}
          >
            <h2
              style={{
                fontFamily: "Georgia, Serif",
                fontWeight: "700",
                letterSpacing: "0.5px",
                fontSize: "1.3rem",
                color: "#222",
                marginBottom: "30px",
              }}
            >
              ABOUT US
            </h2>

            <p
              style={{
                fontFamily: "Minion Pro, serif",
                fontSize: "0.9rem",
                lineHeight: "1.9",
                color: "#333",
                marginBottom: "28px",
              }}
            >
              At SORIN, we believe every scent carries a light, a quiet reflection of who you are and how you move through the world. Inspired by the sun's warmth and radiance, our fragrances are crafted to brighten each moment of your life. SORIN brings light to every mood, from moments of calm to bursts of vibrant energy.
            </p>

            <p
              style={{
                fontFamily: "Minion Pro, serif",
                fontSize: "0.9rem",
                lineHeight: "1.9",
                color: "#333",
                marginBottom: "28px",
              }}
            >
              Our Serene Bliss whispers calmness with a gentle blend of florals and musk that softens the day with soothing elegance. Yet in the heat of passion, Rowdy Party burns brighter, a captivating mix of dawn's fire and night's allure, made for those who live boldly and love deeply.
            </p>

            <p
              style={{
                fontFamily: "Minion Pro, serif",
                fontSize: "0.9rem",
                lineHeight: "1.9",
                color: "#333",
                marginBottom: "40px",
              }}
            >
              Whichever light you wear, may it reflect your glow.
            </p>

            <div 
              className="logo-container"
              style={{
                marginBottom: "60px",
                marginTop: "50px",
              }}
            >
              <p
                style={{
                  marginTop: "0",
                  fontFamily: "Georgia, serif",
                  color: "#333",
                  fontSize: "0.9rem",
                  marginBottom: "14px",
                }}
              >
                From Your Sun,
              </p>
              <img
                src={LogoAbout}
                alt="SORIN logo"
                style={{
                  width: "70px",
                  height: "auto",
                  marginLeft: "-7px",
                }}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BrandProfile;